export default function EventOverviewSkeleton() {
  return (
    <div>
      <div className="pt-8">
        {/* ObjectHeading Skeleton */}
        <div className="mb-8">
          <div className="flex items-start gap-4">
            {/* Icon/Avatar */}
            <div className="animate-pulse rounded-full bg-gradient-to-r from-gray-200 to-gray-50 h-16 w-16 flex-shrink-0" />

            {/* Title and Metadata */}
            <div className="flex-1 min-w-0">
              {/* Title */}
              <div className="animate-pulse h-8 w-64 mb-3 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />

              {/* Metadata */}
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="animate-pulse h-4 w-16 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                  <div className="animate-pulse h-4 w-32 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                </div>
                <div className="flex items-center gap-2">
                  <div className="animate-pulse h-4 w-12 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                  <div className="animate-pulse h-4 w-48 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                </div>
                <div className="flex items-center gap-2">
                  <div className="animate-pulse h-4 w-10 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                  <div className="animate-pulse h-4 w-40 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex items-start gap-2">
              <div className="animate-pulse h-10 w-24 rounded-lg bg-gradient-to-r from-gray-200 to-gray-50" />
              <div className="animate-pulse h-10 w-20 rounded-lg bg-gradient-to-r from-gray-200 to-gray-50" />
              <div className="animate-pulse h-10 w-10 rounded-lg bg-gradient-to-r from-gray-200 to-gray-50" />
            </div>
          </div>

          {/* Status Tag */}
          <div className="mt-4">
            <div className="animate-pulse h-6 w-16 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          </div>
        </div>

        {/* Tabs Skeleton */}
        <div className="mb-6">
          <div className="flex gap-6 border-b border-extended-pgadarknavy-brand-color">
            {Array.from({ length: 4 }).map((_, index) => (
              <div
                key={index}
                className="animate-pulse h-6 w-20 mb-4 rounded-full bg-gradient-to-r from-gray-200 to-gray-50"
              />
            ))}
          </div>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {/* Left Column - Cards */}
          <div className="md:col-span-4 space-y-4">
            {/* Registration Options Card */}
            <div className="border-0 border-b border-sys-brand-secondary-container rounded-2xl p-6 shadow-web-1">
              <div className="animate-pulse h-6 w-48 mb-4 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
              <div className="space-y-4">
                {Array.from({ length: 3 }).map((_, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="animate-pulse h-6 w-6 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                    <div className="flex-1 space-y-2">
                      <div className="animate-pulse h-4 w-24 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                      <div className="animate-pulse h-5 w-36 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Location Card */}
            <div className="border-0 border-b border-sys-brand-secondary-container rounded-2xl p-6 shadow-web-1">
              <div className="animate-pulse h-6 w-24 mb-4 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
              <div className="space-y-4">
                {Array.from({ length: 2 }).map((_, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="animate-pulse h-6 w-6 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                    <div className="flex-1 space-y-2">
                      <div className="animate-pulse h-4 w-32 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                      <div className="animate-pulse h-5 w-48 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Event Details Card */}
            <div className="border-0 border-b border-sys-brand-secondary-container rounded-2xl p-6 shadow-web-1">
              <div className="animate-pulse h-6 w-36 mb-4 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
              <div className="space-y-4">
                {Array.from({ length: 3 }).map((_, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="animate-pulse h-6 w-6 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                    <div className="flex-1 space-y-2">
                      <div className="animate-pulse h-4 w-20 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                      <div className="animate-pulse h-5 w-24 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="md:col-span-8 space-y-6">
            {/* Event Description Section */}
            <div>
              <div className="animate-pulse h-7 w-48 mb-4 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
              <div className="space-y-3">
                <div className="animate-pulse h-4 w-full rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                <div className="animate-pulse h-4 w-5/6 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                <div className="animate-pulse h-4 w-4/5 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                <div className="animate-pulse h-4 w-3/4 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
              </div>
            </div>

            {/* Event Image Section */}
            <div>
              <div className="animate-pulse h-6 w-32 mb-3 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
              <div className="animate-pulse h-4 w-80 mb-4 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
              <div className="animate-pulse h-48 w-full rounded-lg bg-gradient-to-r from-gray-200 to-gray-50" />
            </div>

            {/* Sessions Table */}
            <div>
              <div className="animate-pulse h-6 w-24 mb-4 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
              <div className="border-0 border-b border-sys-brand-secondary-container rounded-2xl shadow-web-1 overflow-hidden">
                {/* Table Header */}
                <div className="bg-sys-brand-surface-container px-4 py-3">
                  <div className="grid grid-cols-6 gap-4">
                    {Array.from({ length: 6 }).map((_, index) => (
                      <div
                        key={index}
                        className="animate-pulse h-5 rounded-full bg-gradient-to-r from-gray-200 to-gray-50"
                      />
                    ))}
                  </div>
                </div>
                {/* Table Rows */}
                {Array.from({ length: 3 }).map((_, index) => (
                  <div key={index} className="px-4 py-3 border-t">
                    <div className="grid grid-cols-6 gap-4 items-center">
                      {Array.from({ length: 6 }).map((_, colIndex) => (
                        <div
                          key={colIndex}
                          className="animate-pulse h-4 rounded-full bg-gradient-to-r from-gray-200 to-gray-50"
                        />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Payment Summary */}
            <div>
              <div className="animate-pulse h-6 w-36 mb-4 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
              <div className="border-0 border-b border-sys-brand-secondary-container rounded-2xl p-6 shadow-web-1">
                <div className="space-y-4">
                  {Array.from({ length: 2 }).map((_, index) => (
                    <div key={index} className="flex justify-between items-center">
                      <div className="animate-pulse h-5 w-32 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                      <div className="animate-pulse h-5 w-20 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                    </div>
                  ))}
                  <hr className="my-4" />
                  <div className="flex justify-between items-center font-semibold">
                    <div className="animate-pulse h-6 w-24 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                    <div className="animate-pulse h-6 w-24 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
